import * as React from 'react'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
// import CssBaseline from '@mui/material/CssBaseline'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import MenuIcon from '@mui/icons-material/Menu'
import Toolbar from '@mui/material/Toolbar'
// import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useNavigate } from 'react-router-dom'

const drawerWidth = 240
const navItems = ['Home', 'Features', 'About', 'Contact']

function DrawerAppBar(props) {
  const navigate = useNavigate()
  const { window } = props
  const [mobileOpen, setMobileOpen] = React.useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState)
  }

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{ textAlign: 'center' }}
      fontFamily='Montserrat Ace'
    >
      {/* <Typography variant='h6' sx={{ my: 2 }}>
        MUI

      </Typography> */}
      <div className='nav-logo'>
        <img
          src='https://media.istockphoto.com/id/1088853426/vector/wireframe-letter-d-outline-bevelled-3d-alphabet-design.jpg?s=612x612&w=is&k=20&c=CMWcbZpZJsvCwqeOgrp7nlufr3v5kw8BXdAV7Mo_koc='
          alt='Dynamind logo'
        />
        <h1>Dynamind</h1>
      </div>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem
            key={item}
            disablePadding
            onClick={() => handleNavLinkClick(item)}
          >
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  )

  const container =
    window !== undefined ? () => window().document.body : undefined

  const handleNavLinkClick = (link) => {
    navigate(`/${link.toLowerCase()}`)
  }

  return (
    <Box sx={{ display: 'flex' }} fontFamily='Montserrat Ace'>
      {/* <CssBaseline /> */}
      <AppBar
        component='nav'
        sx={{ bgcolor: '#4b6e8b', fontFamily: 'Montserrat Ace' }}
        elevation={0}
      >
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            edge='start'
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {/* <Typography
            variant='h6'
            component='div'
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            MUI
          </Typography> */}
          <div className='nav-logo' style={{ flexGrow: 1 }}>
            <img
              src='https://media.istockphoto.com/id/1088853426/vector/wireframe-letter-d-outline-bevelled-3d-alphabet-design.jpg?s=612x612&w=is&k=20&c=CMWcbZpZJsvCwqeOgrp7nlufr3v5kw8BXdAV7Mo_koc='
              alt='Dynamind logo'
            />
            <h1>Dynamind</h1>
          </div>
          <Box
            sx={{ display: { xs: 'none', sm: 'block' } }}
            fontFamily='Montserrat Ace'
          >
            {navItems.map((item) => (
              <Button
                key={item}
                sx={{ color: '#fff' }}
                // href={`/${item.toLowerCase()}`}
                // onClick={navigate(`/${item.toLowerCase()}`)}
                onClick={() => handleNavLinkClick(item)}
              >
                {item}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <Box component='nav'>
        <Drawer
          container={container}
          variant='temporary'
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box component='main' sx={{ p: 4 }}>
        {/* <Toolbar /> */}
      </Box>
    </Box>
  )
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
}

export default DrawerAppBar
